import { ReactNode, useId } from "react";

export interface FieldProps {
  readonly label: string;
  readonly error?: string;
  readonly children: (inputProps: { id: string; "aria-describedby"?: string }) => ReactNode;
}

/**
 * Field wraps a label + child input + optional inline error text. Uses a
 * render-prop so the child input receives the generated id + `aria-describedby`
 * (wired to the error message for screen readers).
 */
export function Field({ label, error, children }: FieldProps) {
  const id = useId();
  const errorId = error ? `${id}-error` : undefined;

  return (
    <div className="flex flex-col gap-1">
      <label htmlFor={id} className="text-sm font-medium text-slate-200">
        {label}
      </label>
      {children({ id, "aria-describedby": errorId })}
      {error ? (
        <p id={errorId} className="text-xs text-red-400" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}
